// BEGIN falconBackpackGalleryRestore20260715
;(function falconBackpackGalleryRestore20260715() {
  var config = {
  "handle": "seibertron-falcon-water-repellent-hiking-camping-backpack-compact-pack-summit-bag",
  "entries": [
    {
      "key": "khaki-main",
      "id": "33449078554814",
      "color": "Khaki",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-khaki-main-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Khaki | slot:1 | Seibertron Falcon backpack khaki 37L motorcycle riding backpack main scene"
    },
    {
      "key": "black-main",
      "id": "33449078587582",
      "color": "Black",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-black-main-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Black | slot:2 | Seibertron Falcon backpack black 37L motorcycle riding backpack scene"
    },
    {
      "key": "black-back",
      "id": "33449078620350",
      "color": "Black",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-black-back-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Black | slot:3 | Seibertron Falcon backpack black 37L backpack rear wearing scene"
    },
    {
      "key": "khaki-side",
      "id": "33449078653118",
      "color": "Khaki",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-khaki-side-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Khaki | slot:4 | Seibertron Falcon backpack khaki 37L backpack side riding scene"
    },
    {
      "key": "khaki-back",
      "id": "33449078685886",
      "color": "Khaki",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-falcon-backpack-khaki-back-20260715.jpg?v=1784085217",
      "alt": "seibertron-gallery:falcon-backpack-20260715 | product:falcon-backpack | color:Khaki | slot:5 | Seibertron Falcon backpack khaki 37L backpack rear riding scene"
    }
  ]
};
  var entries = config.entries || [];
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValue(scope) {
    var checked = scope.querySelector('input[name^="options["]:checked');
    if (checked) return checked.value || '';
    var selected = scope.querySelector('[data-auto-visual-option-value] input:checked');
    var label = selected && selected.closest('[data-auto-visual-option-value]');
    return label ? label.getAttribute('data-auto-visual-option-value') || selected.value || '' : '';
  }
  function selectedIs37L(scope) {
    return /(?:Black|Khaki)\s+37L/i.test(selectedValue(scope));
  }
  function selectedMain(scope) {
    var value = selectedValue(scope);
    if (/Black\s+37L/i.test(value)) return entries.find(function (entry) { return entry.key === 'black-main'; }) || entries[0];
    return entries.find(function (entry) { return entry.key === 'khaki-main'; }) || entries[0];
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    if (thumb.dataset.falconGalleryBound !== 'true') {
      thumb.dataset.falconGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate(scope) {
    if (!selectedIs37L(scope)) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    var ids = {};
    entries.forEach(function (entry, index) {
      var thumb = ensureThumb(scope, wrap, entry, index);
      ids[String(entry.id)] = true;
      thumb.classList.toggle('is-active', entry.id === selectedMain(scope).id);
    });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var show = !!ids[String(thumb.getAttribute('data-media-id') || '')];
      thumb.hidden = !show;
      thumb.style.display = show ? '' : 'none';
      thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    setMain(scope, selectedMain(scope));
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate(scope);
    if (scope.dataset.falconBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.falconBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[name^="options["]')) {
        [0, 150, 600, 1200].forEach(function (delay) { window.setTimeout(run, delay); });
      }
    });
    var observer = new MutationObserver(function () { window.setTimeout(run, 40); });
    observer.observe(scope, { childList: true, subtree: true });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  var attempts = 0;
  var timer = window.setInterval(function () {
    attempts += 1;
    run();
    if (attempts >= 100) window.clearInterval(timer);
  }, 150);
})();
// END falconBackpackGalleryRestore20260715
